import * as React from "react";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: 'outline';
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", variant = "outline", ...props }, ref) => {
    const baseStyles = "min-h-[80px] px-3 py-2 text-sm w-full bg-white border border-neutral-300 rounded-md text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-black/5 disabled:opacity-50 disabled:pointer-events-none transition-all duration-200";

    return (
      <textarea
        ref={ref}
        className={`${baseStyles} ${className}`}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";


